import axios from 'axios';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { BiChevronLeft } from 'react-icons/bi';
import OtpInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from 'src/baseUrl';
import Button from 'src/components/button';
import LabelCustomSelect from 'src/components/LabelSelect/LabelCustomSelect';
import PasswordTextfield from 'src/components/password-textfield';
import TextField from 'src/components/text-field';
import { CurrencyAmount } from 'src/containers/currency';
import { useSubscriptionModels } from 'src/redux/action/dashLayoutHeading.action';
import { loginConstant } from 'src/redux/constant';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const Login: React.FC<IProps> = ({}) => {
  const [errorMsg, setErrorMsg] = React.useState('');
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const location = useLocation();
  const [showEnterPinLogin, setShowEnterPinLogin] = useState(
    location.state?.switchAccount
  );
  const [showSubscriptionOptions, setShowSubscriptionOptions] = useState(false);
  const [subscriptionIdIndex, setSubscriptionIdIndex] = useState(0);
  const [businessId, setBusinessId] = useState('');
  const [switchAccount, setSwitchAccount] = useState(
    location.state?.switchAccount
  );
  const [code, setCode] = React.useState('');
  const [pinLoading, setPinLoading] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const { data } = useSubscriptionModels();

  const handleChange = (code: string, submitForm: () => void) => {
    setCode(code);
    if (code.length === 4) {
      submitForm(); // Submit the form when code length is 4
    }
  };

  const initVal = {
    email: '',
    password: '',
    rememberMe: false,
  };

  // useEffect(() => {
  //   const handleKeyPress = (event: any) => {
  //     if (showEnterPinLogin && event.key === 'Enter') {
  //       event.preventDefault();
  //       handleLoginPin();
  //     }
  //   };

  //   if (showEnterPinLogin) {
  //     document.addEventListener('keydown', handleKeyPress);
  //   } else {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   }

  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, []);

  const handleLogin = async (val: any) => {
    //  dispatch(loginAction(val));
    // setErrorMsg(auth?.error);
    if (loginLoading) return;
    setLoginLoading(true);
    const lowercaseEmail = val.email.toLowerCase();

    try {
      const { data } = await Service.post('/employees/login', {
        ...val,
        email: lowercaseEmail,
      });
      // setAccessToken(data?.data?.access_token);
      setLoginLoading(false);
      if(!data?.data?.businessSubscriptionInfo) setShowSubscriptionOptions(true)
      else setShowEnterPinLogin(true);
      setBusinessId(data?.data?.businessInfo?.id)
      setAccessToken(data?.data?.access_token);
      window.localStorage.setItem('accessToken_init', data?.data?.access_token);
    } catch (err: any) {
      setLoginLoading(false);
      toastAlert(
        'error',
        err?.response?.data?.message ?? 'Something went wrong.'
      );
    }
  };

  const handleLoginPin = async () => {
    // if (pinLoading) return;
    // if (code.length !== 4) {
    //   return;
    // }
    // setPinLoading(true);
    try {
      const token = switchAccount
        ? window.localStorage.getItem('accessToken_init')
        : accessToken;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const requestData = {
        pin: code,
      };

      const response = await axios.post(
        `${BASE_URL}/employees/login/pin`,
        requestData,
        config
      );

      const data = response.data;

      setPinLoading(false);
      const userInfo = {
        businessInfo: data?.data?.businessInfo ?? '',
        userInfo: data?.data?.employeeInfo ?? '',
        accessToken: data?.data?.access_token ?? '',
        role: data?.data?.employeeInfo?.designation || '',
        permissions: data?.data?.employeeInfo?.permissions || {}
      };
      // Store access token based on "Remember Me" checkbox
      const expirationTime = rememberMe
        ? 30 * 24 * 60 * 60 * 1000
        : 12 * 60 * 60 * 1000;

      const expirationDate = new Date().getTime() + expirationTime;

      window.localStorage.setItem(
        'accessToken',
        JSON.stringify(data?.data?.access_token ?? '')
      );

      window.localStorage.setItem('expiresAt', JSON.stringify(expirationDate));

      dispatch({
        type: loginConstant.LOGIN_SUCCESS,
        payload: [userInfo.accessToken, userInfo.role],
      });
      window.localStorage.setItem('data', JSON.stringify(data));

      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
      window.localStorage.setItem('role', JSON.stringify(userInfo.role));
      navigate('/dine-in');
    } catch (err: any) {
      setLoginLoading(false);
      toastAlert(
        'error',
        err?.response?.data?.message ?? 'Something went wrong.'
      );
      setPinLoading(false);
    }
  };
  
  const handleSubscriptionInfo = async () => {
    try {
      const token = switchAccount
        ? window.localStorage.getItem('accessToken_init')
        : accessToken;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const requestData = {
        subscriptionId: data[subscriptionIdIndex].id,
        businessId
       };
      await axios.post(
        `${BASE_URL}/business-subscriptions/subscribe`,
        requestData,
        config
      );
      setShowSubscriptionOptions(false)
      setShowEnterPinLogin(true);
    } catch (err: any) {
      setLoginLoading(false);
      toastAlert(
        'error',
        err?.response?.data?.message ?? 'Something went wrong.'
      );
      setPinLoading(false);
    }
  };

  const handleSubClick = (index: number) => {
    setSubscriptionIdIndex(index)
  }

  if(showSubscriptionOptions) {
    return(
      <div className="max-h-screen mx-auto max-w-[477px]">
        <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
          <div
            className="mt-[150px] w-10 h-10 rounded-[50%] bg-primary-light"
            onClick={() => setShowSubscriptionOptions(false)}
          >
            <BiChevronLeft size={'40px'} style={{ color: '#4062FF' }} />
          </div>
          <div className="my-6">
            <h1 className="text-4xl font-semibold mb-5">Select Subscription</h1>
            <p className="text-light-grey text-base">
              Select the model most-suited for you.
            </p>
            <div className='flex flex-col gap-4 mt-5'>
              {data?.map((each: any, index: number) => (
                <div onClick={()=>handleSubClick(index)}
                 key={'subs'+index} 
                 className={`flex flex-col gap-1 py-4 px-6 border rounded-xl max-w-[310px] ${subscriptionIdIndex===index? 'border-primary border-2' : 'border-light-grey'}`}>
                  <p className='font-semibold'>{each.name}</p>
                  <p className='text-secondary-0'>{each.description}</p>
                  <p><CurrencyAmount amount={each.price}/></p>
                </div>
              ))}
            </div>
            <Button
              text={'Submit'}
              onClick={handleSubscriptionInfo}
              variant="primary"
              className="w-full mt-5 h-[40px]"
            />
          </div>
        </div>
      </div>
    )
  }

  if (showEnterPinLogin) {
    return (
      <div className="max-h-screen mx-auto max-w-[477px]">
        <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
          <div
            className="mt-[150px] w-10 h-10 rounded-[50%] bg-primary-light"
            onClick={() => setShowEnterPinLogin(false)}
          >
            <BiChevronLeft size={'40px'} style={{ color: '#4062FF' }} />
          </div>
          <div className="my-6">
            <h1 className="text-4xl font-semibold mb-5">Pin Verification</h1>
            <p className="text-light-grey text-base">
              Enter the pin assigned to you.
            </p>
            <Formik
              initialValues={{ code: '' }}
              onSubmit={handleLoginPin}
              validateOnMount
            >
              {({ isSubmitting, isValid, submitForm }) => (
                <Form className="flex flex-col mt-7 gap-5 justify-center">
                  <OtpInput
                    value={code}
                    onChange={(newCode: string) =>
                      handleChange(newCode, submitForm)
                    }
                    numInputs={4}
                    separator={<span style={{ width: '20px' }}></span>}
                    isInputNum={true}
                    shouldAutoFocus={true}
                    className="mt-5 ds"
                    containerStyle={{
                      justifyContent: 'space-between',
                    }}
                    inputStyle={{
                      border: '1px solid #CACFE3',
                      borderRadius: '8px',
                      width: '64px',
                      height: '64px',
                      fontSize: '15px',
                      color: '#000',
                      fontWeight: '400',
                    }}
                    focusStyle={{
                      border: '1px solid #4062FF',
                      outline: 'none',
                    }}
                  />

                  <Button
                    text={pinLoading ? 'Submitting...' : 'Submit'}
                    type="submit"
                    variant="primary"
                    className="w-full mt-5 h-[40px]"
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div></div>{' '}
      {/* blank div to center the login form to middle of the screen */}
      <Formik
        initialValues={initVal}
        onSubmit={handleLogin}
        validateOnMount
        validationSchema={FORM_VALIDATION}
      >
        {({ isSubmitting, isValid }) => (
          <Form className="mt-10">
            <h1 className="text-4xl font-semibold mb-5">Login</h1>
            {errorMsg && (
              <p className="text-center text-warning font-semibold">
                {errorMsg}
              </p>
            )}
            <TextField
              label="Email"
              name="email"
              placeholder="Enter your email address"
            />
            <PasswordTextfield name="password" label="Password" />
            <div className="flex items-center justify-between flex-wrap">
              <div className="flex items-center align-middle content-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  className="my-1 mr-2"
                />
                <label htmlFor="rememberMe" className="text-sm">
                  Remember Me
                </label>
              </div>
              {/* <Link to="/forget-password"> */}
              <div className="flex justify-end">
                <p
                  onClick={() => navigate('/forget-password')}
                  className="text-primary text-xs font-semibold text-end cursor-pointer"
                >
                  Forgot Password?
                </p>
              </div>
            </div>
            {/* </Link> */}
            <Button
              text={loginLoading ? 'Logging...' : 'Login'}
              type="submit"
              variant="primary"
              className="w-full mt-5 "
              isSubmitting={isSubmitting}
              isValid={isValid}
            />
          </Form>
        )}
      </Formik>
      <p className="mt-5 text-center bg-[url('/btn-gradient.svg')] font-regular text-pure-white bg-cover flex justify-between px-4 py-3 rounded-xl text-sm">
        {`New to Novus?`}
        <span
          onClick={() => navigate('/register')}
          className="font-semibold cursor-pointer"
        >
          Register
        </span>
      </p>
    </>
  );
};

export default React.memo(Login);
